import { NgModule } from '@angular/core';
import { MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { SecurityHeaderInterceptor } from './shared/services/security-header-interceptor.service';
import { routes } from './app-routing.module';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import { AppComponent } from './app.component';

const msalConfig = {
  auth: {
    clientId: environment.msClientId,
    authority: environment.msAuthority,
    redirectUri: environment.redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

@NgModule({
  imports: [
    BrowserModule,
    MsalModule.forRoot(
      new PublicClientApplication(msalConfig),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: [`api://${environment.msClientId}/access_as_user`],
        },
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
          [
            environment.accessEndpoint,
            [`api://${environment.msClientId}/access_as_user`],
          ],
        ]),
      },
    ),
  ],
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([SecurityHeaderInterceptor])),
    AuthService,
    ScreenService,
    AppInfoService,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
